import { MapRef } from 'react-map-gl';

import { LatLong } from 'src/common/external/aws/suggestPois';

export function addLineStringSource(
  map: MapRef,
  layerId: string,
  start: LatLong,
  end: LatLong
) {
  let lineStringSource;
  try {
    lineStringSource = map.getSource(layerId);
    if (lineStringSource) return;

    map.getMap().addSource(layerId, {
      type: 'geojson',
      data: {
        type: 'Feature',
        properties: {},
        geometry: {
          type: 'LineString',
          coordinates: [
            [start.long, start.lat],
            [end.long, end.lat],
          ],
        },
      },
    });
  } catch (error) {
    // TODO: failing silently -- styles load after our data
    // map.loaded() didn't really work in ensuring the styles loaded first
    // This is a temp workaround
    // console.error(error);
    // console.error('layerId for above error', layerId);
    // console.error('start lat/lng', start);
    // console.error('end lat/lng', end);
  }
}
